/* eslint-disable consistent-return */

import store from 'web-app/react/redux/store';
import * as AccountSelectors from 'web-app/react/session/account/selectors';
import * as SessionSelectors from 'web-app/react/session/selectors';
import {DebugLocalStorageFlags, checkIfFlagIsToggled} from 'web-app/react/routes/debugger/local-storage-config';
import ENV from 'web-app/config/environment';

const intercomInstalled = () => window.Intercom;

let didBoot = false;

const boot = () => {
    const state = store.getState();

    const intercomV2 = AccountSelectors.intercomV2(state);
    const isImpersonated = SessionSelectors.isImpersonated(state);
    const isDebugFlagToggled = checkIfFlagIsToggled(DebugLocalStorageFlags.ENABLE_INTERCOM_TEST_ENVIRONMENT.flag);

    if (!intercomInstalled() || isImpersonated) {
        return;
    }

    // prevent intercom from booting in cypress tests to avoid creating test users
    if (window.Cypress) {
        return;
    }

    if (intercomV2) {
        // boot intercom if we are in production environment or if we are in dev environment and the debug flag is enabled
        if (!ENV.isDevelopment || isDebugFlagToggled) {
            window.Intercom('boot', intercomV2);

            didBoot = true;
        }
    }
};

export const isIntercomAvailable = () => {
    return intercomInstalled() && window.Intercom?.booted && didBoot;
};

const shutdown = () => {
    if (!isIntercomAvailable()) {
        return false;
    }

    window.Intercom('shutdown');
};

const show = () => {
    if (!isIntercomAvailable()) {
        return false;
    }

    window.Intercom('show');
};

const update = () => {
    if (!isIntercomAvailable()) {
        return false;
    }

    window.Intercom('update', {
        nonce: new Date(),
    });
};

const startSurvey = surveyId => {
    if (!isIntercomAvailable()) {
        return false;
    }

    window.Intercom('startSurvey', surveyId);
};

export default {
    isIntercomAvailable,
    boot,
    show,
    shutdown,
    update,
    startSurvey,
};
